/**
 * Callable hooks for the application About form's location field. The
 * request/response types are the shared wire contract in
 * `@cip/core/geolocation`; the functions handlers import the same module, so
 * there is no longer a copy to keep in sync here.
 */

import {useCipHttpsCallable} from '../../../../firebase/functions/use_cip_https_callable';
import type {
  PlaceSuggestionRequest,
  PlaceSuggestionResponse,
  PlaceFromGeocodeRequest,
  PlaceFromGeocodeResponse,
  PlaceDetailsRequest,
  PlaceDetailsResponse,
} from '@cip/core/geolocation';

// Re-export the shared types so existing importers of this module keep working.
export type * from '@cip/core/geolocation';

export const usePlaceSuggestion = () => {
  return useCipHttpsCallable<PlaceSuggestionRequest, PlaceSuggestionResponse>(
    'getplacesuggestion',
  );
};

export const usePlaceFromGeocode = () => {
  return useCipHttpsCallable<PlaceFromGeocodeRequest, PlaceFromGeocodeResponse>(
    'getplacefromgeocode',
  );
};

export const usePlaceDetails = () => {
  return useCipHttpsCallable<PlaceDetailsRequest, PlaceDetailsResponse>(
    'getplacedetails',
  );
};
